var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJudicialApartments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 90,
    viewBox: "0 0 84 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10683",
    "data-name": "Group 10683",
    transform: "translate(-1245.587 -660.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10224",
    "data-name": "Path 10224",
    d: "M417.245,189.845A1.24,1.24,0,0,1,416,188.6V161.311a1.241,1.241,0,1,1,2.483,0V188.6A1.24,1.24,0,0,1,417.245,189.845Zm0,0",
    transform: "translate(896.474 530.6)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10225",
    "data-name": "Path 10225",
    d: "M81.277,189.845a1.24,1.24,0,0,1-1.241-1.241V161.311a1.241,1.241,0,1,1,2.483,0V188.6A1.24,1.24,0,0,1,81.277,189.845Zm0,0",
    transform: "translate(1180.892 530.6)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10226",
    "data-name": "Path 10226",
    d: "M199.617,82.5h-22.34a1.241,1.241,0,0,1,0-2.483h22.34a1.241,1.241,0,1,1,0,2.483Zm0,0",
    transform: "translate(1099.497 598.684)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10227",
    "data-name": "Path 10227",
    d: "M199.617,450.491h-22.34a1.241,1.241,0,0,1,0-2.483h22.34a1.241,1.241,0,1,1,0,2.483Zm0,0",
    transform: "translate(1099.497 286.891)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    transform: "translate(1300.674 660.684)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 14.456,
    ry: 14.456,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 13.956,
    ry: 13.956,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10542",
    "data-name": "Group 10542",
    transform: "translate(1274.473 711.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10541",
    "data-name": "Group 10541",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10108",
    "data-name": "Path 10108",
    d: "M14.867,395.259a2.056,2.056,0,0,0-1.656-3.272H3.229a2.054,2.054,0,0,0-1.655,3.272A2.938,2.938,0,0,0,0,397.859v.587a.587.587,0,0,0,.587.587H15.853a.587.587,0,0,0,.587-.587v-.587A2.938,2.938,0,0,0,14.867,395.259Zm-12.261-1.84a.875.875,0,0,1,.623-.258h9.982a.881.881,0,1,1,0,1.762H3.229a.881.881,0,0,1-.623-1.5Zm-1.432,4.439A1.764,1.764,0,0,1,2.936,396.1H13.5a1.764,1.764,0,0,1,1.761,1.762Z",
    transform: "translate(0.219 -391.768)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10108_-_Outline",
    "data-name": "Path 10108 - Outline",
    d: "M3.2,391.737H13.18a2.275,2.275,0,0,1,1.966,3.417,3.148,3.148,0,0,1,1.482,2.673v.587a.807.807,0,0,1-.806.806H.556a.807.807,0,0,1-.806-.806v-.587a3.147,3.147,0,0,1,1.483-2.674A2.273,2.273,0,0,1,3.2,391.737Zm12.624,7.046a.369.369,0,0,0,.369-.369v-.587a2.714,2.714,0,0,0-1.456-2.406l-.225-.119.151-.2a1.818,1.818,0,0,0,.356-1.088,1.838,1.838,0,0,0-1.836-1.836H3.2A1.835,1.835,0,0,0,1.719,395.1l.151.2-.225.118a2.713,2.713,0,0,0-1.458,2.406v.587a.369.369,0,0,0,.369.369ZM3.2,392.911H13.18a1.1,1.1,0,1,1,0,2.2H3.2a1.1,1.1,0,1,1,0-2.2Zm9.982,1.762a.662.662,0,0,0,0-1.324H3.2a.662.662,0,0,0,0,1.324ZM2.9,395.847H13.473a1.982,1.982,0,0,1,1.98,1.98v.219H.924v-.219A1.982,1.982,0,0,1,2.9,395.847ZM15,397.609a1.545,1.545,0,0,0-1.527-1.324H2.9a1.545,1.545,0,0,0-1.527,1.324Z",
    transform: "translate(0.25 -391.737)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10645",
    "data-name": "Group 10645",
    transform: "translate(1274.468 690.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10540",
    "data-name": "Group 10540",
    transform: "translate(5.763 9.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10539",
    "data-name": "Group 10539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10107",
    "data-name": "Path 10107",
    d: "M101.707,171.592a.587.587,0,1,0,0,.83A.588.588,0,0,0,101.707,171.592Z",
    transform: "translate(-100.486 -171.201)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10107_-_Outline",
    "data-name": "Path 10107 - Outline",
    d: "M101.26,171.17a.806.806,0,1,1-.57.236A.8.8,0,0,1,101.26,171.17Zm0,1.174a.369.369,0,1,0-.261-.108A.365.365,0,0,0,101.26,172.344Z",
    transform: "translate(-100.454 -171.17)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10544",
    "data-name": "Group 10544",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10543",
    "data-name": "Group 10543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10109",
    "data-name": "Path 10109",
    d: "M28.825,24.074a3.608,3.608,0,0,0-.69-.793l-2.677-2.335a.569.569,0,0,0-.228-.2L23.61,19.335,16.115,12.8a1.716,1.716,0,0,0-.5-2.737l.693-.693a2.293,2.293,0,0,0,2.213-.592,2.292,2.292,0,0,0,0-3.241L13.656.673A2.291,2.291,0,0,0,9.823,2.885L2.9,9.8a2.306,2.306,0,0,0-.593-.078,2.292,2.292,0,0,0-1.62,3.912L5.553,18.5a2.291,2.291,0,0,0,3.834-2.213l.692-.692a1.719,1.719,0,0,0,2.738.5L20.8,25.268a.575.575,0,0,0,.078.1l.032.029,2.379,2.733c.059.07.122.138.188.2A3.408,3.408,0,0,0,25.9,29.339a3.517,3.517,0,0,0,.482-.033,3.467,3.467,0,0,0,2.558-1.771A3.39,3.39,0,0,0,28.825,24.074ZM11.225,1.483a1.146,1.146,0,0,1,1.621,0l4.862,4.862a1.146,1.146,0,0,1-1.62,1.621L11.226,3.1h0A1.147,1.147,0,0,1,11.225,1.483ZM7.984,17.689a1.147,1.147,0,0,1-1.621,0L1.5,12.827a1.146,1.146,0,0,1,1.62-1.621l4.863,4.863A1.147,1.147,0,0,1,7.984,17.689ZM10.4,13.656l-1.6,1.6L3.932,10.4l6.483-6.483,4.862,4.862-1.605,1.605-.016.015-3.24,3.24Zm2.046,1.2,0,0-.4.4a.573.573,0,0,1-.818-.8L14.473,11.2a.573.573,0,0,1,.972.412.568.568,0,0,1-.168.405l-.4.4-.008.008Zm1.187.434L15.3,13.611,22.395,19.8l-2.587,2.587Zm6.932,7.964,2.7-2.7.866.755-2.81,2.81Zm7.376,3.725a2.331,2.331,0,0,1-1.715,1.2,2.277,2.277,0,0,1-1.937-.649c-.044-.044-.086-.09-.126-.136l-.006-.006-2.085-2.4,2.922-2.922,2.392,2.087.005,0a2.467,2.467,0,0,1,.473.544A2.262,2.262,0,0,1,27.938,26.974Z",
    transform: "translate(0.198 0.218)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10109_-_Outline",
    "data-name": "Path 10109 - Outline",
    d: "M25.87,29.526a3.619,3.619,0,0,1-2.574-1.07c-.07-.07-.137-.143-.2-.217l-2.368-2.72-.032-.03a.786.786,0,0,1-.1-.119l-7.837-9a1.933,1.933,0,0,1-2.531-.177A1.944,1.944,0,0,1,10,15.911l-.411.411a2.516,2.516,0,0,1-.677,2.3,2.509,2.509,0,0,1-3.545,0L.5,13.757A2.507,2.507,0,0,1,2.8,9.534L9.554,2.783a2.516,2.516,0,0,1,.677-2.3,2.506,2.506,0,0,1,3.544,0l4.864,4.863a2.505,2.505,0,0,1-2.3,4.221l-.412.412a1.932,1.932,0,0,1,.454,2.762l8.938,7.8a.782.782,0,0,1,.186.137.8.8,0,0,1,.082.1l2.658,2.319a3.818,3.818,0,0,1,.729.838,3.607,3.607,0,0,1,.12,3.681,3.68,3.68,0,0,1-2.716,1.879A3.744,3.744,0,0,1,25.87,29.526ZM12.8,15.758l8.142,9.355.008.013a.364.364,0,0,0,.049.061l.02.018.012.01,2.39,2.746q.086.1.178.193a3.2,3.2,0,0,0,2.272.945,3.314,3.314,0,0,0,.453-.031,3.257,3.257,0,0,0,2.4-1.665,3.176,3.176,0,0,0-.106-3.241,3.4,3.4,0,0,0-.65-.746l-2.7-2.356-.016-.024a.366.366,0,0,0-.046-.056.359.359,0,0,0-.1-.069l-.026-.012L15.776,12.78l.154-.161a1.5,1.5,0,0,0-.441-2.4l-.274-.13.995-.995.119.032a2.094,2.094,0,0,0,.538.071,2.078,2.078,0,0,0,1.47-3.549L13.474.787a2.079,2.079,0,0,0-2.941,0A2.088,2.088,0,0,0,10,2.795l.032.119L2.933,10.007l-.119-.032a2.1,2.1,0,0,0-.539-.071,2.079,2.079,0,0,0-1.47,3.549l4.864,4.864a2.082,2.082,0,0,0,2.941,0,2.088,2.088,0,0,0,.537-2.008l-.032-.119.992-.992.13.272a1.507,1.507,0,0,0,2.4.44ZM25.873,28.379a2.484,2.484,0,0,1-1.767-.734c-.048-.048-.094-.1-.138-.15l0,0-2.216-2.546,3.2-3.2L27.5,23.962a2.682,2.682,0,0,1,.514.591,2.482,2.482,0,0,1,.083,2.5,2.543,2.543,0,0,1-1.873,1.3A2.571,2.571,0,0,1,25.873,28.379Zm-3.541-3.414,1.962,2.255c.036.042.074.084.113.123a2.06,2.06,0,0,0,1.465.609,2.143,2.143,0,0,0,.293-.02,2.12,2.12,0,0,0,1.559-1.089,2.044,2.044,0,0,0-.069-2.059,2.256,2.256,0,0,0-.432-.5l-.01-.009-2.24-1.954ZM21.276,24.4l-1.035-1.19,2.982-2.982,1.188,1.037Zm-.452-1.169.474.544,2.488-2.488-.544-.474Zm-1.057-.564-6.461-7.423,1.957-1.957,7.415,6.468Zm-5.877-7.4,5.9,6.777,2.265-2.265-6.771-5.906ZM7.14,18.207a1.351,1.351,0,0,1-.962-.4L1.315,12.946a1.36,1.36,0,0,1,1.922-1.924L8.1,15.887a1.359,1.359,0,0,1-.962,2.32ZM2.276,11.052a.933.933,0,0,0-.659,1.592L6.48,17.508A.933.933,0,0,0,7.8,16.189L2.935,11.324A.926.926,0,0,0,2.276,11.052ZM11.6,15.608a.786.786,0,0,1-.565-1.334l3.258-3.258A.787.787,0,0,1,15.4,12.136l-3.242,3.242A.782.782,0,0,1,11.6,15.608Zm3.242-4.388a.356.356,0,0,0-.25.1l-3.254,3.254a.352.352,0,0,0-.1.247.36.36,0,0,0,.615.255L15.1,11.834a.359.359,0,0,0-.255-.614ZM8.761,15.529,3.6,10.363l6.787-6.787,5.166,5.166-5.013,5.013-.014.014-.006.006ZM4.2,10.363l4.562,4.562,1.45-1.45.023-.024,3.24-3.24.018-.017,1.453-1.453L10.382,4.18ZM16.867,8.48a1.35,1.35,0,0,1-.961-.4L11.042,3.219A1.36,1.36,0,1,1,12.965,1.3l4.864,4.863a1.359,1.359,0,0,1-.961,2.321ZM12,1.324a.933.933,0,0,0-.659,1.592l4.864,4.864a.933.933,0,1,0,1.319-1.32L12.663,1.6A.927.927,0,0,0,12,1.324Z",
    transform: "translate(0.229 0.249)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10546",
    "data-name": "Group 10546",
    transform: "translate(7.364 5.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10545",
    "data-name": "Group 10545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10110",
    "data-name": "Path 10110",
    d: "M132.479,100.879a.587.587,0,0,0-.83,0l-2.491,2.491a.587.587,0,1,0,.83.83l2.491-2.491A.587.587,0,0,0,132.479,100.879Z",
    transform: "translate(-128.767 -100.489)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10110_-_Outline",
    "data-name": "Path 10110 - Outline",
    d: "M132.032,100.457a.806.806,0,0,1,.57,1.376l-2.491,2.491a.806.806,0,1,1-1.14-1.14l2.491-2.491A.8.8,0,0,1,132.032,100.457Zm-2.491,3.666a.366.366,0,0,0,.261-.108l2.491-2.491a.369.369,0,0,0-.521-.521l-2.491,2.491a.369.369,0,0,0,.261.629Z",
    transform: "translate(-128.735 -100.457)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_118-2",
    "data-name": "Ellipse 118",
    transform: "translate(1245.587 660.684)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 14.456,
    ry: 14.456,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 13.956,
    ry: 13.956,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_118-3",
    "data-name": "Ellipse 118",
    transform: "translate(1300.674 721.771)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 14.456,
    ry: 14.456,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 13.956,
    ry: 13.956,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_118-4",
    "data-name": "Ellipse 118",
    transform: "translate(1245.587 721.771)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 14.456,
    ry: 14.456,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.456,
    cy: 14.456,
    rx: 13.956,
    ry: 13.956,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_-_Flaticon-3",
    "data-name": "Search results for House - Flaticon-3",
    transform: "translate(1306.506 667.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10616",
    "data-name": "Group 10616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10615",
    "data-name": "Group 10615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10228",
    "data-name": "Path 10228",
    d: "M16.925,32.277l-3.147-2.771c0-.019.007-.038.011-.061V25.822a.4.4,0,0,0-.379-.4H11.653a.389.389,0,0,0-.368.4v1.5L8.768,25.109a.359.359,0,0,0-.478,0L.133,32.273a.387.387,0,0,0-.048.534.36.36,0,0,0,.518.049l.007-.008L8.529,25.9l2.834,2.49,1.695,1.486,3.393,2.979a.36.36,0,0,0,.518-.042A.391.391,0,0,0,16.925,32.277ZM13.05,28.866l-1.029-.895V26.186H13.05Z",
    transform: "translate(0.097 -24.92)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10228_-_Outline",
    "data-name": "Path 10228 - Outline",
    d: "M.215,32.89a.453.453,0,0,1-.357-.174.487.487,0,0,1,.061-.669l8.156-7.164a.465.465,0,0,1,.3-.115.454.454,0,0,1,.3.116l2.355,2.071V25.669a.488.488,0,0,1,.465-.5h1.761a.5.5,0,0,1,.473.494v3.649l3.105,2.734a.491.491,0,0,1,.056.669.457.457,0,0,1-.659.053L12.842,29.8l-1.695-1.486-2.77-2.434L.515,32.78A.469.469,0,0,1,.215,32.89Zm8.164-7.927a.269.269,0,0,0-.176.067L.045,32.2a.29.29,0,0,0-.034.4.259.259,0,0,0,.2.1.273.273,0,0,0,.171-.062L.4,32.624l7.983-7.009,2.9,2.547,1.695,1.486,3.393,2.98a.263.263,0,0,0,.174.067.266.266,0,0,0,.2-.1.293.293,0,0,0-.034-.4L13.52,29.39l.011-.055c0-.016.006-.032.009-.05V25.669a.3.3,0,0,0-.283-.3H11.5a.294.294,0,0,0-.27.3v1.717L8.552,25.03A.26.26,0,0,0,8.379,24.963ZM13,28.928l-1.225-1.064V25.936H13Zm-1.029-1.154.834.725V26.131h-.834Z",
    transform: "translate(0.248 -24.768)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10618",
    "data-name": "Group 10618",
    transform: "translate(1.675 2.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10617",
    "data-name": "Group 10617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10229",
    "data-name": "Path 10229",
    d: "M57.786,88.037l-1.025-.874L51.3,82.505a.366.366,0,0,0-.474,0l-5.463,4.658-1.025.874a.363.363,0,0,0-.04.514.356.356,0,0,0,.5.044l0,0,.456-.393v6.829a.385.385,0,0,0,.376.375H56.484a.382.382,0,0,0,.376-.375V88.2l.456.393a.363.363,0,0,0,.234.087.369.369,0,0,0,.277-.127A.36.36,0,0,0,57.786,88.037Zm-5.266,6.632H49.6V90.736h2.919Zm.73,0V90.383a.363.363,0,0,0-.35-.375H49.222a.363.363,0,0,0-.35.375v4.287H45.989V87.575l5.072-4.312,5.072,4.312v7.094Z",
    transform: "translate(-44.111 -82.32)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10229_-_Outline",
    "data-name": "Path 10229 - Outline",
    d: "M50.91,82.168a.459.459,0,0,1,.3.111L57.7,87.811a.452.452,0,0,1,.162.312.458.458,0,0,1-.111.339.465.465,0,0,1-.351.161.459.459,0,0,1-.3-.11l-.3-.255v6.615a.479.479,0,0,1-.472.473H45.483a.485.485,0,0,1-.474-.471V88.259l-.3.258a.46.46,0,0,1-.751-.39.46.46,0,0,1,.161-.316l1.026-.874,5.463-4.658A.47.47,0,0,1,50.91,82.168Zm6.487,6.26a.273.273,0,0,0,.2-.094.264.264,0,0,0,.065-.2.259.259,0,0,0-.093-.179l-1.026-.875-5.463-4.658a.263.263,0,0,0-.172-.064.274.274,0,0,0-.176.064L44.247,87.96a.266.266,0,0,0-.029.375.258.258,0,0,0,.363.035l.006-.006.618-.533v7.042a.287.287,0,0,0,.28.277H56.331a.283.283,0,0,0,.278-.279v-7.04l.618.533A.265.265,0,0,0,57.4,88.428Zm-6.488-5.446,5.17,4.4v7.237H53V90.231a.266.266,0,0,0-.253-.277H49.07a.266.266,0,0,0-.253.277v4.384H45.739V87.377Zm4.974,4.485-4.974-4.229-4.974,4.229v6.952h2.687V90.231a.461.461,0,0,1,.448-.473h3.678a.461.461,0,0,1,.448.473v4.189h2.687Zm-6.532,3.018h3.115v4.129H49.352Zm2.919.2H49.547v3.738h2.724Z",
    transform: "translate(-43.958 -82.168)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_-_Flaticon-3-2",
    "data-name": "Search results for House - Flaticon-3",
    transform: "translate(1306.506 728.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10616-2",
    "data-name": "Group 10616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10615-2",
    "data-name": "Group 10615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10228-2",
    "data-name": "Path 10228",
    d: "M16.925,32.277l-3.147-2.771c0-.019.007-.038.011-.061V25.822a.4.4,0,0,0-.379-.4H11.653a.389.389,0,0,0-.368.4v1.5L8.768,25.109a.359.359,0,0,0-.478,0L.133,32.273a.387.387,0,0,0-.048.534.36.36,0,0,0,.518.049l.007-.008L8.529,25.9l2.834,2.49,1.695,1.486,3.393,2.979a.36.36,0,0,0,.518-.042A.391.391,0,0,0,16.925,32.277ZM13.05,28.866l-1.029-.895V26.186H13.05Z",
    transform: "translate(0.097 -24.92)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10228_-_Outline-2",
    "data-name": "Path 10228 - Outline",
    d: "M.215,32.89a.453.453,0,0,1-.357-.174.487.487,0,0,1,.061-.669l8.156-7.164a.465.465,0,0,1,.3-.115.454.454,0,0,1,.3.116l2.355,2.071V25.669a.488.488,0,0,1,.465-.5h1.761a.5.5,0,0,1,.473.494v3.649l3.105,2.734a.491.491,0,0,1,.056.669.457.457,0,0,1-.659.053L12.842,29.8l-1.695-1.486-2.77-2.434L.515,32.78A.469.469,0,0,1,.215,32.89Zm8.164-7.927a.269.269,0,0,0-.176.067L.045,32.2a.29.29,0,0,0-.034.4.259.259,0,0,0,.2.1.273.273,0,0,0,.171-.062L.4,32.624l7.983-7.009,2.9,2.547,1.695,1.486,3.393,2.98a.263.263,0,0,0,.174.067.266.266,0,0,0,.2-.1.293.293,0,0,0-.034-.4L13.52,29.39l.011-.055c0-.016.006-.032.009-.05V25.669a.3.3,0,0,0-.283-.3H11.5a.294.294,0,0,0-.27.3v1.717L8.552,25.03A.26.26,0,0,0,8.379,24.963ZM13,28.928l-1.225-1.064V25.936H13Zm-1.029-1.154.834.725V26.131h-.834Z",
    transform: "translate(0.248 -24.768)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10618-2",
    "data-name": "Group 10618",
    transform: "translate(1.675 2.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10617-2",
    "data-name": "Group 10617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10229-2",
    "data-name": "Path 10229",
    d: "M57.786,88.037l-1.025-.874L51.3,82.505a.366.366,0,0,0-.474,0l-5.463,4.658-1.025.874a.363.363,0,0,0-.04.514.356.356,0,0,0,.5.044l0,0,.456-.393v6.829a.385.385,0,0,0,.376.375H56.484a.382.382,0,0,0,.376-.375V88.2l.456.393a.363.363,0,0,0,.234.087.369.369,0,0,0,.277-.127A.36.36,0,0,0,57.786,88.037Zm-5.266,6.632H49.6V90.736h2.919Zm.73,0V90.383a.363.363,0,0,0-.35-.375H49.222a.363.363,0,0,0-.35.375v4.287H45.989V87.575l5.072-4.312,5.072,4.312v7.094Z",
    transform: "translate(-44.111 -82.32)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10229_-_Outline-2",
    "data-name": "Path 10229 - Outline",
    d: "M50.91,82.168a.459.459,0,0,1,.3.111L57.7,87.811a.452.452,0,0,1,.162.312.458.458,0,0,1-.111.339.465.465,0,0,1-.351.161.459.459,0,0,1-.3-.11l-.3-.255v6.615a.479.479,0,0,1-.472.473H45.483a.485.485,0,0,1-.474-.471V88.259l-.3.258a.46.46,0,0,1-.751-.39.46.46,0,0,1,.161-.316l1.026-.874,5.463-4.658A.47.47,0,0,1,50.91,82.168Zm6.487,6.26a.273.273,0,0,0,.2-.094.264.264,0,0,0,.065-.2.259.259,0,0,0-.093-.179l-1.026-.875-5.463-4.658a.263.263,0,0,0-.172-.064.274.274,0,0,0-.176.064L44.247,87.96a.266.266,0,0,0-.029.375.258.258,0,0,0,.363.035l.006-.006.618-.533v7.042a.287.287,0,0,0,.28.277H56.331a.283.283,0,0,0,.278-.279v-7.04l.618.533A.265.265,0,0,0,57.4,88.428Zm-6.488-5.446,5.17,4.4v7.237H53V90.231a.266.266,0,0,0-.253-.277H49.07a.266.266,0,0,0-.253.277v4.384H45.739V87.377Zm4.974,4.485-4.974-4.229-4.974,4.229v6.952h2.687V90.231a.461.461,0,0,1,.448-.473h3.678a.461.461,0,0,1,.448.473v4.189h2.687Zm-6.532,3.018h3.115v4.129H49.352Zm2.919.2H49.547v3.738h2.724Z",
    transform: "translate(-43.958 -82.168)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_-_Flaticon-3-3",
    "data-name": "Search results for House - Flaticon-3",
    transform: "translate(1251.419 728.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10616-3",
    "data-name": "Group 10616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10615-3",
    "data-name": "Group 10615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10228-3",
    "data-name": "Path 10228",
    d: "M16.925,32.277l-3.147-2.771c0-.019.007-.038.011-.061V25.822a.4.4,0,0,0-.379-.4H11.653a.389.389,0,0,0-.368.4v1.5L8.768,25.109a.359.359,0,0,0-.478,0L.133,32.273a.387.387,0,0,0-.048.534.36.36,0,0,0,.518.049l.007-.008L8.529,25.9l2.834,2.49,1.695,1.486,3.393,2.979a.36.36,0,0,0,.518-.042A.391.391,0,0,0,16.925,32.277ZM13.05,28.866l-1.029-.895V26.186H13.05Z",
    transform: "translate(0.097 -24.92)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10228_-_Outline-3",
    "data-name": "Path 10228 - Outline",
    d: "M.215,32.89a.453.453,0,0,1-.357-.174.487.487,0,0,1,.061-.669l8.156-7.164a.465.465,0,0,1,.3-.115.454.454,0,0,1,.3.116l2.355,2.071V25.669a.488.488,0,0,1,.465-.5h1.761a.5.5,0,0,1,.473.494v3.649l3.105,2.734a.491.491,0,0,1,.056.669.457.457,0,0,1-.659.053L12.842,29.8l-1.695-1.486-2.77-2.434L.515,32.78A.469.469,0,0,1,.215,32.89Zm8.164-7.927a.269.269,0,0,0-.176.067L.045,32.2a.29.29,0,0,0-.034.4.259.259,0,0,0,.2.1.273.273,0,0,0,.171-.062L.4,32.624l7.983-7.009,2.9,2.547,1.695,1.486,3.393,2.98a.263.263,0,0,0,.174.067.266.266,0,0,0,.2-.1.293.293,0,0,0-.034-.4L13.52,29.39l.011-.055c0-.016.006-.032.009-.05V25.669a.3.3,0,0,0-.283-.3H11.5a.294.294,0,0,0-.27.3v1.717L8.552,25.03A.26.26,0,0,0,8.379,24.963ZM13,28.928l-1.225-1.064V25.936H13Zm-1.029-1.154.834.725V26.131h-.834Z",
    transform: "translate(0.248 -24.768)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10618-3",
    "data-name": "Group 10618",
    transform: "translate(1.675 2.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10617-3",
    "data-name": "Group 10617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10229-3",
    "data-name": "Path 10229",
    d: "M57.786,88.037l-1.025-.874L51.3,82.505a.366.366,0,0,0-.474,0l-5.463,4.658-1.025.874a.363.363,0,0,0-.04.514.356.356,0,0,0,.5.044l0,0,.456-.393v6.829a.385.385,0,0,0,.376.375H56.484a.382.382,0,0,0,.376-.375V88.2l.456.393a.363.363,0,0,0,.234.087.369.369,0,0,0,.277-.127A.36.36,0,0,0,57.786,88.037Zm-5.266,6.632H49.6V90.736h2.919Zm.73,0V90.383a.363.363,0,0,0-.35-.375H49.222a.363.363,0,0,0-.35.375v4.287H45.989V87.575l5.072-4.312,5.072,4.312v7.094Z",
    transform: "translate(-44.111 -82.32)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10229_-_Outline-3",
    "data-name": "Path 10229 - Outline",
    d: "M50.91,82.168a.459.459,0,0,1,.3.111L57.7,87.811a.452.452,0,0,1,.162.312.458.458,0,0,1-.111.339.465.465,0,0,1-.351.161.459.459,0,0,1-.3-.11l-.3-.255v6.615a.479.479,0,0,1-.472.473H45.483a.485.485,0,0,1-.474-.471V88.259l-.3.258a.46.46,0,0,1-.751-.39.46.46,0,0,1,.161-.316l1.026-.874,5.463-4.658A.47.47,0,0,1,50.91,82.168Zm6.487,6.26a.273.273,0,0,0,.2-.094.264.264,0,0,0,.065-.2.259.259,0,0,0-.093-.179l-1.026-.875-5.463-4.658a.263.263,0,0,0-.172-.064.274.274,0,0,0-.176.064L44.247,87.96a.266.266,0,0,0-.029.375.258.258,0,0,0,.363.035l.006-.006.618-.533v7.042a.287.287,0,0,0,.28.277H56.331a.283.283,0,0,0,.278-.279v-7.04l.618.533A.265.265,0,0,0,57.4,88.428Zm-6.488-5.446,5.17,4.4v7.237H53V90.231a.266.266,0,0,0-.253-.277H49.07a.266.266,0,0,0-.253.277v4.384H45.739V87.377Zm4.974,4.485-4.974-4.229-4.974,4.229v6.952h2.687V90.231a.461.461,0,0,1,.448-.473h3.678a.461.461,0,0,1,.448.473v4.189h2.687Zm-6.532,3.018h3.115v4.129H49.352Zm2.919.2H49.547v3.738h2.724Z",
    transform: "translate(-43.958 -82.168)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_-_Flaticon-3-4",
    "data-name": "Search results for House - Flaticon-3",
    transform: "translate(1251.419 667.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10616-4",
    "data-name": "Group 10616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10615-4",
    "data-name": "Group 10615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10228-4",
    "data-name": "Path 10228",
    d: "M16.925,32.277l-3.147-2.771c0-.019.007-.038.011-.061V25.822a.4.4,0,0,0-.379-.4H11.653a.389.389,0,0,0-.368.4v1.5L8.768,25.109a.359.359,0,0,0-.478,0L.133,32.273a.387.387,0,0,0-.048.534.36.36,0,0,0,.518.049l.007-.008L8.529,25.9l2.834,2.49,1.695,1.486,3.393,2.979a.36.36,0,0,0,.518-.042A.391.391,0,0,0,16.925,32.277ZM13.05,28.866l-1.029-.895V26.186H13.05Z",
    transform: "translate(0.097 -24.92)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10228_-_Outline-4",
    "data-name": "Path 10228 - Outline",
    d: "M.215,32.89a.453.453,0,0,1-.357-.174.487.487,0,0,1,.061-.669l8.156-7.164a.465.465,0,0,1,.3-.115.454.454,0,0,1,.3.116l2.355,2.071V25.669a.488.488,0,0,1,.465-.5h1.761a.5.5,0,0,1,.473.494v3.649l3.105,2.734a.491.491,0,0,1,.056.669.457.457,0,0,1-.659.053L12.842,29.8l-1.695-1.486-2.77-2.434L.515,32.78A.469.469,0,0,1,.215,32.89Zm8.164-7.927a.269.269,0,0,0-.176.067L.045,32.2a.29.29,0,0,0-.034.4.259.259,0,0,0,.2.1.273.273,0,0,0,.171-.062L.4,32.624l7.983-7.009,2.9,2.547,1.695,1.486,3.393,2.98a.263.263,0,0,0,.174.067.266.266,0,0,0,.2-.1.293.293,0,0,0-.034-.4L13.52,29.39l.011-.055c0-.016.006-.032.009-.05V25.669a.3.3,0,0,0-.283-.3H11.5a.294.294,0,0,0-.27.3v1.717L8.552,25.03A.26.26,0,0,0,8.379,24.963ZM13,28.928l-1.225-1.064V25.936H13Zm-1.029-1.154.834.725V26.131h-.834Z",
    transform: "translate(0.248 -24.768)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10618-4",
    "data-name": "Group 10618",
    transform: "translate(1.675 2.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10617-4",
    "data-name": "Group 10617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10229-4",
    "data-name": "Path 10229",
    d: "M57.786,88.037l-1.025-.874L51.3,82.505a.366.366,0,0,0-.474,0l-5.463,4.658-1.025.874a.363.363,0,0,0-.04.514.356.356,0,0,0,.5.044l0,0,.456-.393v6.829a.385.385,0,0,0,.376.375H56.484a.382.382,0,0,0,.376-.375V88.2l.456.393a.363.363,0,0,0,.234.087.369.369,0,0,0,.277-.127A.36.36,0,0,0,57.786,88.037Zm-5.266,6.632H49.6V90.736h2.919Zm.73,0V90.383a.363.363,0,0,0-.35-.375H49.222a.363.363,0,0,0-.35.375v4.287H45.989V87.575l5.072-4.312,5.072,4.312v7.094Z",
    transform: "translate(-44.111 -82.32)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10229_-_Outline-4",
    "data-name": "Path 10229 - Outline",
    d: "M50.91,82.168a.459.459,0,0,1,.3.111L57.7,87.811a.452.452,0,0,1,.162.312.458.458,0,0,1-.111.339.465.465,0,0,1-.351.161.459.459,0,0,1-.3-.11l-.3-.255v6.615a.479.479,0,0,1-.472.473H45.483a.485.485,0,0,1-.474-.471V88.259l-.3.258a.46.46,0,0,1-.751-.39.46.46,0,0,1,.161-.316l1.026-.874,5.463-4.658A.47.47,0,0,1,50.91,82.168Zm6.487,6.26a.273.273,0,0,0,.2-.094.264.264,0,0,0,.065-.2.259.259,0,0,0-.093-.179l-1.026-.875-5.463-4.658a.263.263,0,0,0-.172-.064.274.274,0,0,0-.176.064L44.247,87.96a.266.266,0,0,0-.029.375.258.258,0,0,0,.363.035l.006-.006.618-.533v7.042a.287.287,0,0,0,.28.277H56.331a.283.283,0,0,0,.278-.279v-7.04l.618.533A.265.265,0,0,0,57.4,88.428Zm-6.488-5.446,5.17,4.4v7.237H53V90.231a.266.266,0,0,0-.253-.277H49.07a.266.266,0,0,0-.253.277v4.384H45.739V87.377Zm4.974,4.485-4.974-4.229-4.974,4.229v6.952h2.687V90.231a.461.461,0,0,1,.448-.473h3.678a.461.461,0,0,1,.448.473v4.189h2.687Zm-6.532,3.018h3.115v4.129H49.352Zm2.919.2H49.547v3.738h2.724Z",
    transform: "translate(-43.958 -82.168)",
    fill: "#00641f"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudicialApartments);
export default __webpack_public_path__ + "static/media/judicialApartments.dd961f9cf97e8aeb82bd3a0b66bce2d9.svg";
export { ForwardRef as ReactComponent };